import * as _ from 'underscore';
import * as angular from 'angular';
import { JispPayMerchantListItem } from '../../../app.retailer/modules/core';

class JispPayMerchantSelector {
    static $inject = ['$q', '$uibModal', '$translate'];

    allowAdd: boolean;
    defaultMerchantIds: JispPayMerchantListItem[];
    model: JispPayMerchantListItem;

    all: JispPayMerchantListItem[] = [];
    existingMerchants: JispPayMerchantListItem[] = [];
    filtered: JispPayMerchantListItem[] = [];

    newMerchantID: string = null;

    onChange: () => void;

    private merchantIDsForSearch: JispPayMerchantListItem[] = [];

    constructor(
        private $q: ng.IQService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private $translate: angular.translate.ITranslateService
    ) { }

    $onInit = async () => {
        try {
            Array.prototype.push.apply(this.all, this.existingMerchants);
            _.forEach(this.defaultMerchantIds, (merchant) => {
                if (this.all.length === 0) {
                    this.all.push(merchant);
                }
                let existing = _.filter(this.all, (item) => {
                    return item.MerchantID === merchant.MerchantID;
                });
                if (existing.length === 0) {
                    this.all.push(merchant);
                }
            });
            this.setMerchantForSearch();
            this.refreshFiltered();
        } catch (error) {
            console.warn(error);
        }
    }

    refreshFiltered(search?: string) {

        let keywords = search || null;
        if (keywords && keywords.length > 0) {
            let reg = new RegExp('^.*' + keywords + '.*', 'i');
            this.filtered = _.filter(this.merchantIDsForSearch, (merchantID) => {
                return reg.test(merchantID.MerchantID);
            });
        } else {
            this.filtered = this.merchantIDsForSearch;
        }

        let alreadyexists = [];
        Array.prototype.push.apply(alreadyexists, this.model);
        Array.prototype.push.apply(alreadyexists, this.merchantIDsForSearch);

        if ((keywords) && _.any(alreadyexists, (merchant) => { return merchant.MerchantID.toLowerCase() === keywords.toLowerCase(); })) {
            this.newMerchantID = '';
        } else {
            this.newMerchantID = keywords;
        }
        if (this.allowAdd && this.newMerchantID) {
            this.newMerchantID = this.newMerchantID.trim();
            if (this.newMerchantID.length > 2 && this.filtered.length === 0) {
                this.filtered.push({ MerchantID: '' });
            }
        }
    }

    getFilteredPlaceholder(): string {
        return this.$translate.instant('add_merchant');
    }


    onSelect(merchantID: JispPayMerchantListItem) {
        if (merchantID === this.newMerchantID) {
            return;
        }
        if (!this.model || this.model.MerchantID !== merchantID.MerchantID) {
            this.model = merchantID;
        }
        this.refreshAvailable();
    }

    addNew() {
        if (this.newMerchantID) {
            this.model = {
                ID: -1,
                MerchantID: this.newMerchantID
            };
            this.merchantIDsForSearch.push({ ID: -1, MerchantID: this.newMerchantID });
            this.onSelect(this.model);
        }
    }

    private updateData = async () => {
        this.setMerchantForSearch();
        this.refreshAvailable();
    }

    private setMerchantForSearch() {
        this.merchantIDsForSearch = this.all;
    }

    private refreshAvailable() {
        this.refreshFiltered();
    }
}

angular.module('app.retailes.common').component('jispPayMerchantSelector', {
    template: require('./jisppay-merchant-selector.html'),
    controller: JispPayMerchantSelector,
    controllerAs: 'vm',
    bindings: {
        allowAdd: '<',
        defaultMerchantIds: '<',
        existingMerchants: '<',
        model: '='
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/components/jisppay-merchant-selector/jisppay-merchant-selector.component.ts